import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ICONS } from '@core/services/icons/icons.service';

/**
 * Small presentational badge shown on a timeline task block that has comments.
 * It is non-interactive (pointer-events: none) — the task block's own click opens
 * the step popup. Matches the imported design's comment badge.
 */
@Component({
  selector: 'app-comment-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <span
      class="pointer-events-none inline-flex h-4 min-w-4 items-center justify-center gap-0.5 rounded-full border-2 px-1 font-mono text-[9px] font-bold text-white shadow-sm"
      [style.background]="resolved() ? 'var(--success)' : 'var(--accent-main)'"
      [style.border-color]="'var(--bg-surface)'"
      [attr.aria-hidden]="true">
      <i [class]="icon()" class="text-[8px]"></i>
      <span>{{ count() }}</span>
    </span>
  `,
  styles: ``
})
export class CommentIndicatorComponent {
  readonly count = input.required<number>();
  readonly resolved = input<boolean>(false);

  protected readonly icon = computed(() =>
    this.resolved() ? ICONS.check : ICONS.chatCircle
  );
}
